(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('slick-carousel');

	var slider = $('#fullscreen-slideshow').find('div.slides');
	var nav = $('#fullscreen-slideshow').find('nav');

	slider.slick({
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		speed: 200,
		autoplay: false,
	//	adaptiveHeight: true // This actually works out as equalHeight in our case because .slick-list gets a height set and our slides are 100% height :D
	});

	// "Select" first nav button
	nav.find('li').eq(0).addClass('active');

	// Hook up our custom navigation
	nav.find('li').each(function (i) {
		$(this).find('a').on('click', function (e) {
			e.preventDefault();
			slider.slick('slickGoTo', i);
		});
	});

	// Update navigation when user changes slide
	slider.on('afterChange', function (e, s, currSlide) {
		nav.find('.active').removeClass('active');
		nav.find('li').eq(currSlide).addClass('active');
	});
})();
